/**
 * Chunk A1 — Gate hard-delete of manual GR POs.
 * Delete only while still open (Not Saved) and with no invoice linked.
 * Void (Slice B) is the path once receipting / invoicing has started.
 * GR tab access is enough to delete/void later — no extra role gate.
 */

export const GR_MANUAL_PLACED_VIA = 'Order placed manually on the dashboard'

export const GR_DELETE_MANUAL_COPY = {
  deleteTooltip: 'Delete manual order',
  /** A alone omitted Void; B2 ships Void — point blocked delete here. */
  blockedTooltip:
    'This order can’t be deleted because it’s receipted or has an invoice. Use Void instead.',
}

export function isManualDashboardGoodsReceiptingOrder(order = {}) {
  return order?.placedVia === GR_MANUAL_PLACED_VIA
}

/** Invoice attached or linked on the GR row. */
export function hasGoodsReceiptingInvoiceLinked(order = {}) {
  return (
    Boolean(order?.invoiceUrl) ||
    Boolean(order?.invoiceKey) ||
    (Array.isArray(order?.attachedInvoicesUrls) &&
      order.attachedInvoicesUrls.length > 0) ||
    (Array.isArray(order?.attachedInvoices) &&
      order.attachedInvoices.length > 0) ||
    (Array.isArray(order?.attachedInvoiceDetails) &&
      order.attachedInvoiceDetails.length > 0)
  )
}

/**
 * True once receipting has moved past open Not Saved
 * (Full accept, Saved, credit workflow, CN Requested, etc.).
 */
export function hasGoodsReceiptingProgress(order = {}) {
  const status = String(order?.receiptingStatus || '').trim()
  if (!status || status === 'Not Saved') return false
  return true
}

export function canDeleteManualGoodsReceiptingOrder(order = {}) {
  if (!isManualDashboardGoodsReceiptingOrder(order)) return false
  if (hasGoodsReceiptingProgress(order)) return false
  if (hasGoodsReceiptingInvoiceLinked(order)) return false
  return true
}

/** Tooltip when the Delete control is shown but blocked. */
export function getDeleteManualGoodsReceiptingDisabledReason(order = {}) {
  if (!isManualDashboardGoodsReceiptingOrder(order)) return null
  if (canDeleteManualGoodsReceiptingOrder(order)) return null
  return GR_DELETE_MANUAL_COPY.blockedTooltip
}
